import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import {
	ITextInput,
	TextInput,
	TextInputAlign,
} from '~/components/ui/TextInput';
import { Placeholder, Wrapper } from './InputWithIcon.styled';

type NativeInputProps = Omit<
	React.InputHTMLAttributes<HTMLInputElement>,
	'height'
>;

interface IInputWithIcon extends ITextInput, NativeInputProps {
	placeholder?: string;
	iconSrc?: string;
}

const InputWithIcon = ({
	placeholder,
	iconSrc,
	textAlign = TextInputAlign.Left,
	value,
	defaultValue,
	...props
}: IInputWithIcon) => {
	const isEmpty = useMemo(() => {
		const v = (value ?? defaultValue ?? '') as string;
		return v === '' || v === undefined || v === null;
	}, [value, defaultValue]);

	return (
		<Wrapper>
			<TextInput
				{...props}
				textAlign={textAlign}
				value={value}
				defaultValue={defaultValue}
			/>

			<Placeholder $visible={isEmpty && Boolean(iconSrc)}>
				{iconSrc ? <img src={iconSrc} alt="" /> : null}
				<Text>{placeholder}</Text>
			</Placeholder>
		</Wrapper>
	);
};

export { InputWithIcon };
